module.exports = __webpack_public_path__ + "img/Ellipse3.91474121.png";